import { Typography } from "@material-ui/core";
import React from "react";
import { useI18n } from "../../../hooks/useI18n";

export const InclVat = () => {
  const { t } = useI18n();

  return (
    <Typography
      style={{ float: "right" }}
      color="textSecondary"
      variant="caption"
    >
      {t("common.inclVat")}
    </Typography>
  );
};
